module.exports = __webpack_public_path__ + "img/dio@2x.2fbffd44.png";